import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=0a70e3e4&scoped=true&"
import script from "./TeacherProfile.vue?vue&type=script&lang=js&"
export * from "./TeacherProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeacherProfile.vue?vue&type=style&index=0&id=0a70e3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70e3e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
